import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import locations from './locations/reducers';
export const rootReducer = combineReducers({ locations });
export const configureStore = (preloadedState = {}) => {
    const middleware = composeWithDevTools(applyMiddleware(thunk));
    const reduxStore = createStore(rootReducer, preloadedState, middleware);
    return reduxStore;
};
const store = configureStore({});
export default store;
